import { useState, useEffect } from 'react'
import { API_URL, sb } from '../utils/config'
import { studioEvents } from '../utils/metaPixel'

// ════════════════════════════════════════════════════════════════
// BANDEAU AVIS — « Aide-moi à améliorer Merlin » (directives Antonin 08/07).
// Discret, tout en haut de la page. Apparaît à partir de la 2e CONNEXION
// (jours distincts sur cet appareil), après 5 minutes de session. Fermable
// définitivement. Répondre = 1 ticket tirage coaching 1:1 (1 par compte).
// ════════════════════════════════════════════════════════════════

const DISMISS_KEY = 'studio_avis_dismissed'
const DONE_KEY = 'studio_avis_done'
const CONN_KEY = 'studio_conn_days'
// 5 minutes de session (override localStorage 'studio_avis_delay_ms' pour les tests)
const DELAY_MS = (() => { try { return Number(localStorage.getItem('studio_avis_delay_ms')) || 5 * 60 * 1000 } catch { return 5 * 60 * 1000 } })()

// Jours de connexion distincts (localStorage, appareil courant)
function connectionDays() {
  try {
    const today = new Date().toISOString().slice(0, 10)
    const days = JSON.parse(localStorage.getItem(CONN_KEY) || '[]')
    if (!days.includes(today)) {
      days.push(today)
      localStorage.setItem(CONN_KEY, JSON.stringify(days.slice(-30)))
    }
    return days.length
  } catch { return 0 }
}

export default function AvisBanner({ sourcePage = 'studio_home' }) {
  const [msg, setMsg] = useState('')
  const [state, setState] = useState('waiting') // waiting | idle | sending | done | hidden
  const [gotTicket, setGotTicket] = useState(false)

  useEffect(() => {
    try {
      if (localStorage.getItem(DONE_KEY) === '1' || localStorage.getItem(DISMISS_KEY) === '1') return
    } catch { return }
    if (connectionDays() < 2) return // 2e connexion minimum
    const t = setTimeout(async () => {
      // Déjà répondu depuis un autre appareil ? (ticket avis en base)
      try {
        const { data } = await sb.auth.getSession()
        const token = data?.session?.access_token
        if (!token) return
        const r = await fetch(`${API_URL}/api/studio/rituel`, { headers: { Authorization: `Bearer ${token}` } })
        if (r.ok && (await r.json()).tickets?.avis > 0) {
          try { localStorage.setItem(DONE_KEY, '1') } catch {}
          return
        }
      } catch { /* au bénéfice du doute : on affiche */ }
      setState('idle')
    }, DELAY_MS)
    return () => clearTimeout(t)
  }, [])

  if (state === 'waiting' || state === 'hidden') return null

  async function send() {
    if (msg.trim().length < 3 || state === 'sending') return
    setState('sending')
    try {
      const { data } = await sb.auth.getSession()
      const token = data?.session?.access_token
      const r = await fetch(`${API_URL}/api/studio/avis`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify({ message: msg.trim(), url: window.location.href }),
      })
      const j = await r.json()
      if (!r.ok) throw new Error(j.error || `HTTP ${r.status}`)
      setGotTicket(!!j.ticket)
      setState('done')
      try { localStorage.setItem(DONE_KEY, '1') } catch {}
      try { studioEvents.tabClicked?.({ tab: 'avis_submitted', source_page: sourcePage }) } catch {}
    } catch {
      setState('idle')
    }
  }

  function dismiss() {
    setState('hidden')
    try { localStorage.setItem(DISMISS_KEY, '1') } catch {}
    try { studioEvents.tabClicked?.({ tab: 'avis_dismissed', source_page: sourcePage }) } catch {}
  }

  if (state === 'done') {
    return (
      <div className="rounded-xl px-3.5 py-2.5 mb-3" style={{ background: 'rgba(124,58,237,0.05)', border: '1px solid rgba(124,58,237,0.15)' }}>
        <p className="text-[12.5px] text-ink">
          Merci, je lis tout. {gotTicket && <>🎟️ Ton ticket pour le tirage <b>1h de coaching 1:1</b> est enregistré. <a href="/jeu-concours" className="underline text-ink-muted">Règlement</a></>}
        </p>
      </div>
    )
  }

  // Bandeau DISCRET : une ligne + champ libre, fermable
  return (
    <div className="rounded-xl px-3.5 py-2.5 mb-3 relative" style={{ background: 'rgba(124,58,237,0.05)', border: '1px solid rgba(124,58,237,0.15)' }}>
      <button type="button" onClick={dismiss} aria-label="Fermer"
        className="absolute top-2 right-2.5 text-ink-faint hover:text-ink text-[13px] leading-none">✕</button>
      <p className="text-[12.5px] text-ink pr-5 leading-snug">
        <b>Aide-moi à améliorer Merlin</b> : dis-moi comment je peux construire l'outil parfait pour toi.
      </p>
      <div className="mt-1.5 flex gap-1.5">
        <input value={msg} onChange={(e) => setMsg(e.target.value)} maxLength={2000}
          onKeyDown={(e) => { if (e.key === 'Enter') send() }}
          placeholder="Il me manque..."
          className="flex-1 min-w-0 text-[12.5px] rounded-lg border border-black/10 bg-white px-2.5 py-1.5 focus:outline-none focus:ring-1 focus:ring-violet-300" />
        <button type="button" onClick={send} disabled={msg.trim().length < 3 || state === 'sending'}
          className="shrink-0 px-3 py-1.5 rounded-lg text-[12px] font-bold text-white disabled:opacity-40"
          style={{ background: '#7c3aed' }}>
          {state === 'sending' ? '...' : 'Envoyer'}
        </button>
      </div>
      <p className="text-[10.5px] text-ink-faint mt-1">🎟️ Ton avis = 1 ticket pour le tirage 1h de coaching 1:1</p>
    </div>
  )
}
